/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type RioVehicleAttributesQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
}>

export type RioVehicleAttributesQuery = {
  __typename?: 'Query'
  vehicleByID: {
    __typename?: 'Vehicle'
    id: string
    attributes: Array<{
      __typename?: 'VehicleAttribute'
      attributeName: Types.VehicleAttributeName
      attributeValue: string
    }> | null
  }
}

export const RioVehicleAttributesDocument = gql`
    query RioVehicleAttributes($id: ID!) {
  vehicleByID(id: $id) {
    id
    attributes {
      attributeName
      attributeValue
    }
  }
}
    `

/**
 * __useRioVehicleAttributesQuery__
 *
 * To run a query within a React component, call `useRioVehicleAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRioVehicleAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRioVehicleAttributesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRioVehicleAttributesQuery(
  baseOptions: Apollo.QueryHookOptions<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  > &
    (
      | { variables: RioVehicleAttributesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  >(RioVehicleAttributesDocument, options)
}
export function useRioVehicleAttributesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  >(RioVehicleAttributesDocument, options)
}
// @ts-ignore
export function useRioVehicleAttributesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  RioVehicleAttributesQuery,
  RioVehicleAttributesQueryVariables
>
export function useRioVehicleAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioVehicleAttributesQuery,
        RioVehicleAttributesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  RioVehicleAttributesQuery | undefined,
  RioVehicleAttributesQueryVariables
>
export function useRioVehicleAttributesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RioVehicleAttributesQuery,
        RioVehicleAttributesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    RioVehicleAttributesQuery,
    RioVehicleAttributesQueryVariables
  >(RioVehicleAttributesDocument, options)
}
export type RioVehicleAttributesQueryHookResult = ReturnType<
  typeof useRioVehicleAttributesQuery
>
export type RioVehicleAttributesLazyQueryHookResult = ReturnType<
  typeof useRioVehicleAttributesLazyQuery
>
export type RioVehicleAttributesSuspenseQueryHookResult = ReturnType<
  typeof useRioVehicleAttributesSuspenseQuery
>
export type RioVehicleAttributesQueryResult = Apollo.QueryResult<
  RioVehicleAttributesQuery,
  RioVehicleAttributesQueryVariables
>
